import { FlyoutIndustryCatalog } from '@mp/content-manager/plattformkataloge/data-access';

import { SortableCatalog } from './industriekataloge-list/sortable-katalog-list/models';

export function flyoutIndustriekatalogToSortierbarerKatalog(
  industryCatalog: FlyoutIndustryCatalog,
  order: number,
): SortableCatalog {
  const { covinRate, articleTotalCount, articleErrorCount, ...rest } = industryCatalog;

  return {
    ...rest,
    order,

    updatedCovinRate: covinRate,
    articleCount: {
      total: articleTotalCount,
    },
    isUpdated: false,
    reservedPublish: false,
    isRemoved: false,
  };
}
